import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export const useAccountSegments = (definitions) =>
	useQuery({
		queryKey: ['get-account-segments', definitions],
		queryFn: async () => {
			const payload = await axios.post('/api/firebase/get-account-segments', {
				definitions
			})

			return payload.data
		},
		initialData: []
	})
